import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ROUTES } from '../../../../common/constants';
import NewOrderTable from './components/NewOrderTable';
import UserReturnTable from './components/ReturnTable';
import New from './pages/CombinedOrders';

const UserOrdersWrapper = () => (
  <Switch>
    <Route
      exact
      path={`${ROUTES?.ORDERS}${ROUTES?.COMBINED_ORDERS}`}
      render={(props) => <New {...props} />}
    />

    <Route
      exact
      path={`${ROUTES?.ORDERS}${ROUTES?.COMBINED_ORDERS}${ROUTES?.NEW}/:userId`}
      render={(props) => <NewOrderTable {...props} />}
    />

    <Route
      exact
      path={`${ROUTES?.ORDERS}${ROUTES?.COMBINED_ORDERS}${ROUTES?.RETURN}/:userId`}
      render={(props) => <UserReturnTable {...props} />}
    />
  </Switch>
);

export default UserOrdersWrapper;
